<template>
  <div class="relative h-auto w-full min-h-0 m-0 mb-4 md:m-4 bg-green-100 rounded-2xl overflow-hidden rounded-br-none">
    <div
      class="absolute top-[50px] left-[50px] w-[calc(100%-50px)] h-[calc(100%-50px)] rounded-tl-xl shadow-xl flex overflow-hidden"
    >
      <!-- Sidebar -->
      <div class="w-[265px] bg-gray-800 flex flex-col shrink-0">
        <!-- Firm Name Header -->
        <div class="flex h-[65px] shrink-0 items-center px-5 bg-gray-900">
          <p class="w-full min-w-0 text-white font-medium text-xl leading-snug line-clamp-2">
            {{ displayName }}
          </p>
        </div>
        <!-- Nav Items -->
        <div class="flex flex-col gap-8 px-5 pt-5">
          <div
            v-for="n in 7"
            :key="n"
            class="flex items-center gap-3"
          >
            <div class="w-5 h-5 rounded bg-gray-700 shrink-0"></div>
            <div class="h-4 rounded bg-gray-700 w-full"></div>
          </div>
        </div>
      </div>
      <!-- Content Area -->
      <div class="flex-1 bg-gray-100 flex flex-col min-h-0">
        <div class="bg-white h-[65px] w-full shrink-0"></div>
        <!-- Top bar with cards -->
        <div class="p-5 pr-0 flex gap-5 shrink-0">
          <div class="bg-white h-20 w-full shrink-0 rounded-l lg:w-[80%] lg:rounded"></div>
          <div class="hidden h-20 bg-white rounded-l lg:flex lg:flex-1 lg:min-w-0"></div>
        </div>
        <!-- Main content area -->
        <div class="pl-5 flex-1 min-h-0 flex flex-col">
          <div class="bg-white rounded-l flex-1 min-h-[200px] min-w-0"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

const props = defineProps<{
  firmName?: string
}>()

const displayName = computed(() => props.firmName?.trim() || "Firm Name")
</script>
